import PropTypes from 'prop-types';
import React from 'react';

import DesktopBreakpoint from '../../components/responsiveUtilities/desktop';
import NotDesktopBreakpoint from '../../components/responsiveUtilities/notDesktop';
import TimeSlider from './TimeSlider';
import TimeGrid from './TimeGrid';
import { timeShape } from '../../shapes';


const TimePicker = ({
  times,
  timezone,
  selectedTime,
  setTime,
}) => (
  <div>
    <DesktopBreakpoint>
      <TimeGrid
        times={times}
        timezone={timezone}
        selectedTime={selectedTime}
        setTime={setTime}
      />
    </DesktopBreakpoint>
    <NotDesktopBreakpoint>
      <TimeSlider
        times={times}
        timezone={timezone}
        selectedTime={selectedTime}
        setTime={setTime}
      />
    </NotDesktopBreakpoint>
  </div>
);
TimePicker.propTypes = {
  times: PropTypes.arrayOf(timeShape),
  timezone: PropTypes.string,
  selectedTime: PropTypes.string,
  setTime: PropTypes.func.isRequired,
};
TimePicker.defaultProps = {
  timezone: null,
  times: [],
  selectedTime: '',
};

export default TimePicker;



// WEBPACK FOOTER //
// ./src/app/times/components/TimePicker.jsx